module.exports = __webpack_public_path__ + "img/cool-steel.f18ed9ed.webp";